import { render } from "./ViewQcmStats.vue?vue&type=template&id=05204de8&scoped=true"
import script from "./ViewQcmStats.vue?vue&type=script&lang=js"
export * from "./ViewQcmStats.vue?vue&type=script&lang=js"

import "./ViewQcmStats.vue?vue&type=style&index=0&id=05204de8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05204de8"]])

export default __exports__